import React from "react";
import { Link } from "react-router-dom";
import { NavbarLogo } from "@/components/Logo";
import { Rocket } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#070815] border-t border-white/10 mt-16">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2"><NavbarLogo /><span className="font-display text-lg font-semibold text-white">Shareride<span className="text-[#22D3EE]">.co</span></span></div>
          <p className="mt-3 text-sm text-muted-cosmic max-w-xs">Share rides across the galaxy — safely, simply, together.</p>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white mb-3">Travel</h4>
          <ul className="space-y-2 text-sm text-muted-cosmic">
            <li><Link to="/search" className="hover:text-[#22D3EE]">Search a ride</Link></li>
            <li><Link to="/publish" className="hover:text-[#22D3EE]">Publish a ride</Link></li>
            <li><Link to="/bus" className="hover:text-[#22D3EE]">Bus tickets</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-muted-cosmic">
            <li><span className="hover:text-[#22D3EE] cursor-pointer">About us</span></li>
            <li><span className="hover:text-[#22D3EE] cursor-pointer">How it works</span></li>
            <li><span className="hover:text-[#22D3EE] cursor-pointer">Trust &amp; safety</span></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white mb-3">Support</h4>
          <ul className="space-y-2 text-sm text-muted-cosmic">
            <li><span className="hover:text-[#22D3EE] cursor-pointer">Help center</span></li>
            <li><span className="hover:text-[#22D3EE] cursor-pointer">Contact</span></li>
            <li><span className="hover:text-[#22D3EE] cursor-pointer">Terms</span></li>
          </ul>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-white/10 flex items-center justify-between flex-wrap gap-2">
        <p className="text-xs text-muted-cosmic">© 2026 Shareride.co — all systems orbiting.</p>
        <p className="text-xs text-muted-cosmic flex items-center gap-1"><Rocket size={12} className="text-[#F7C948]" /> Made with cosmic love</p>
      </div>
    </div>
  </footer>
);
